import * as _ from 'lodash';

export class AttributeDefinitionValueListItem {
  public id: string;
  public itemValue: string;
  public itemDescription: string;
  public rank: number;
  public isActive: boolean;
  public added: boolean;

  constructor(id: string, itemValue: string, itemDescription: string, rank: number) {
    this.id = id;
    this.itemValue = itemValue;
    this.itemDescription = itemDescription;
    this.rank = rank;
  }

  hasDescription() {
    return !_.isEmpty(_.trim(this.itemDescription));
  }

  static parse(obj: any): AttributeDefinitionValueListItem {
    return new AttributeDefinitionValueListItem(
      obj.id,
      obj.itemValue,
      obj.itemDescription,
      obj.rank
    );
  }

  static empty(): AttributeDefinitionValueListItem {
    return new AttributeDefinitionValueListItem(null, null, null, 0);
  }
}
